<template>
  <li>
    <div class="row">
      <router-link tag="a" :to="{ name: 'interns.profile.show', params: { id: intern.id }}">
        <div class="col-xs-12 col-md-10">
          <div class="details">
            <h3>{{ intern.name }}</h3>
          </div>
        </div>
      </router-link>
      <div class="col-xs-12 col-md-2">
        <ladda-button
          class="btn btn-lg btn-danger btn-job-complete"
          :click="handleDeleteInternCallback"
          v-if="!intern.deleted_at">
          <template><i class="fa fa-trash"></i> Delete User</template>
        </ladda-button>
        <div
          class="btn btn-danger-outline btn-block btn-not-clickable truncate"
          v-if="intern.deleted_at">
          Deleted
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions } from 'vuex'
import { alert, notify } from 'utils'

export default {
  props: {
    intern: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('intern', ['deleteIntern']),

    handleDeleteInternCallback () {
      return alert.confirm({
        title: 'Delete Intern Account',
        text: 'Are you sure you want to continue and delete the account?',
        buttons: {
          confirm: {
            text: 'Yes, delete account.'
          }
        }
      }).then(() => {
        return this.deleteIntern({id: this.intern.id}).catch(error => {
          if (error.response.status === 400) {
            notify.error(error.response.data.message)
          } else {
            notify.error('Sorry something went wrong, please refresh the page and try again.')
          }
        })
      })
    }
  }
}
</script>
